import { createContext, useContext } from 'react';

/** Provided on a read-only order the viewer is allowed to take. Components
 *  that swallow a click because the viewer is not the owner call it, so the
 *  user is offered ownership instead of a control that silently does nothing. */
export const LockedOrderContext = createContext<(() => void) | null>(null);
export const useLockedOrderPrompt = () => useContext(LockedOrderContext);
